import url from './url';



export default url(({ userId = ':userId' }) => `/administration/${userId}`);
